import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconX = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon-x",
    "data-icon": "icon-x",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsx("line", {
      x1: "18",
      y1: "6",
      x2: "6",
      y2: "18"
    }), jsx("line", {
      x1: "6",
      y1: "6",
      x2: "18",
      y2: "18"
    })]
  }));
});
IconX.displayName = 'IconX';

export { IconX };
//# sourceMappingURL=x.js.map
